export default "__VITE_ASSET__CekW85rA__"